import React from "react";
import { Row, Col, } from "reactstrap";
import "./CSS/StationWiseData.css";



const ReusableCard = ({
  // title,
  shift,
  totalNoOfVehicles,
  totalNoOfVehiclesColor,
  okayVehicles,
  okayVehiclesColor,
  vehiclesWithDefects,
  vehiclesWithDefectsColor,

}) => {


  return (

  //  <Card className="p-1 info_widget justify-content-center ReusableCard">
     
  //     <CardBody>
  <>
        <Row className="mx-2">
          <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="text-center Shift mt-2">
              <span>Shift {shift}</span>
            </Row>
            <Row className="mt-3 content">
              <Row className="mt-2">
                <Col>
                  <span>Total No of Vehicles: </span>
                </Col>
                <Col className="d-flex justify-content-end">
                  <span className={`${totalNoOfVehiclesColor} value-style`}>
                    {totalNoOfVehicles}
                  </span>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <span>Okay Vehicles: </span>
                </Col>
                <Col className="d-flex justify-content-end">
                  <span
                    className={`${okayVehiclesColor} value-style text-nowrap`}
                  >
                    {okayVehicles}
                  </span>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <span>Vehicles with Defects: </span>
                </Col>
                <Col className="d-flex justify-content-end">
                  <span
                    className={`${vehiclesWithDefectsColor} value-style`}
                  >
                    {vehiclesWithDefects}
                  </span>
                </Col>
              </Row>
            </Row>
          </Col>
        </Row>
    {/* //   </CardBody>
    // </Card> */}
 </>
  );
};

export default ReusableCard;
